import { EOSService } from "../../api/eos-service";
import { IOService } from "../../api/io-service";

const state = {
};

const getters = {};

const actions = {
    async GetPeriodBeginAndEndDate(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        if(!params.get('employeeId')){
            params.append('employeeId', perno);
        }

        return await EOSService.makeRequest(IOService.GetPeriodBeginAndEndDate(params))
    },
    async GetFullPeriodIoInfo(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        //console.log(perno);
        if(!params.get('employeeId')){
            params.append('employeeId', perno);
        }

        return await EOSService.makeRequest(IOService.GetFullPeriodIoInfoWithinFlageOfRequestedPages(params))
    },
    async GetPersonIoInfo(state, { params }) {
        return await EOSService.makeRequest(IOService.GetPersonIoInfo(params))
    },
    async GetPersonIoInfoClockDump(state, { params }) {
        return await EOSService.makeRequest(IOService.GetPersonIoInfoClockDump(params))
    },
    async GetPersonMergeIo(state, { params }) {
        return await EOSService.makeRequest(IOService.GetPersonMergeIo(params))
    },
    async AddIO(state, { params }) {
        if (!params.get('perno')) {
            var perno = state.rootState.auth.auth.username;
            params.append('perno', perno);
        }

        return await EOSService.makeRequest(IOService.AddIo(params))
    },
    async GetIoListForArchive(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        if (!params.get('perno')) {
            params.append('perno', perno);
        }
        params.append('sortType', 'desc');
        params.append('sortExpression', 'CLOCKDATE');

        return await EOSService.makeRequest(IOService.GetIoListForArchive(params))
    },
    async GetIoDetail(state, { params }) {
        return await EOSService.makeRequest(IOService.GetIoDetail(params))
    },
    async GetIoDetailForArchive(state, { GetIoDetailForArchiveParams }) {
        var params = new URLSearchParams()
        params.append('perno',GetIoDetailForArchiveParams.perno)
        params.append('date',GetIoDetailForArchiveParams.date)
        params.append('time',GetIoDetailForArchiveParams.time)
        params.append('iotype',GetIoDetailForArchiveParams.iotype)
        params.append('dbkind',GetIoDetailForArchiveParams.dbkind)
        params.append('status',GetIoDetailForArchiveParams.status)
        params.append('year',GetIoDetailForArchiveParams.year)

        return await EOSService.makeRequest(IOService.GetIoDetailForArchive(params))
    },
    async OprationOnInOutArchive(state, { params }) {
        return await EOSService.makeRequest(IOService.OprationOnInOutArchive(params))
    },
    async OprationOnIORequest(state, { params }) {
        return await EOSService.makeRequest(IOService.OprationOnInOutRequest(params))
    },
    async GetIoListForAdmin(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        params['adminPerno'] = perno;
        return await EOSService.makeRequest(IOService.GetIoListForAdmin(params))
    },
    async GetIOApproveDegree(state, { approveParams }) {
        var perno = state.rootState.auth.auth.username;
        approveParams['adminPerno'] = perno;
        return await EOSService.makeRequest(IOService.GetApproveDegree(approveParams))
    },
    async GetIoInfoInDate(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        params['adminPerno'] = perno;
        return await EOSService.makeRequest(IOService.GetIoInfoInDate(params))
    },
    async GetPersonConflict(state, {params}) {
        return await EOSService.makeRequest(IOService.GetPersonConflict(params))
    },
    async GetUnCompleteIo(state, {params}) {
        var perno = state.rootState.auth.auth.username;
        params['adminperno'] = perno;
        return await EOSService.makeRequest(IOService.GetUnCompleteIo(params))
    },
    async GetCompleteIo(state, {params}) {
        var perno = state.rootState.auth.auth.username;
        params['adminperno'] = perno;
        return await EOSService.makeRequest(IOService.GetCompleteIo(params))
    },
    async GetIoInfoDetailForAdmin(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        params.append('adminPerno', perno);
        return await EOSService.makeRequest(IOService.GetIoInfoDetailForAdmin(params))
    },
    async getClocksList() {
        return await EOSService.makeRequest(IOService.getClocksList())
    },
};

const mutations = {
};

export default {
    state,
    getters,
    actions,
    mutations
}